
  export const productData = [
    { name: 'Jan', "Sales": 4000,},
    { name: 'Feb', "Sales": 3000,},
    { name: 'Mar', "Sales": 7000,},
    { name: 'Apr', "Sales": 2780,},
    { name: 'May', "Sales": 1890,},
  ];

  export const userData = [
    { name: 'Jan', "Active User": 4000,},
    { name: 'Feb', "Active User": 3000,},
    { name: 'Mar', "Active User": 7000,},
    { name: 'Apr', "Active User": 2780,},
    { name: 'May', "Active User": 1890,},
    { name: 'Jun', "Active User": 2390,},
    { name: 'Jul', "Active User": 3490,},
    { name: 'Aug', "Active User": 7890,},
    { name: 'Sep', "Active User": 400, },
    { name: 'Oct', "Active User": 5130,},
    { name: 'Nov', "Active User": 8888,},
    { name: 'Dec', "Active User": 102, },
  ];
  
 export const userRows = [
    {
        id: 1,
        username: 'Jon Snow',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "jon@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 2,
        username: 'Lanto Blue',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "Blue@gmail.com",
        status:"active",
        transaction:"$7816.00",
    },
    {
        id: 3,
        username: 'El Capino LOP',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "LOP@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 4,
        username: 'Jon Snow',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "jon@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 5,
        username: 'Lanto Blue',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "Blue@gmail.com",
        status:"active",
        transaction:"$7816.00",
    },
    {
        id: 6,
        username: 'El Capino LOP',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "LOP@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 7,
        username: 'Jon Snow',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "jon@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 8,
        username: 'Lanto Blue',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "Blue@gmail.com",
        status:"active",
        transaction:"$7816.00",
    },
    {
        id: 9,
        username: 'El Capino LOP',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "LOP@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 10,
        username: 'El Capino LOP',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "LOP@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
    {
        id: 11,
        username: 'El Capino LOP',
        avatar: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        email: "LOP@gmail.com",
        status:"active",
        transaction:"$1456.00",
    },
  ];
  

 export const productRows = [
    {
        id: 1,
        name: 'Apple Airpods',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 24,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 2,
        name: 'Blue bottle',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 114,
        status:"active",
        price:"$7816.00",
    },
    {
        id: 3,
        name: 'El Capino cap',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 76,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 4,
        name: 'Apple Airpods',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 24,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 5,
        name: 'Blue bottle',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 114,
        status:"active",
        price:"$7816.00",
    },
    {
        id: 6,
        name: 'El Capino Cap',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 76,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 7,
        name: 'Apple Airpods',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 24,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 8,
        name: 'Blue Cap',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 114,
        status:"active",
        price:"$7816.00",
    },
    {
        id: 9,
        name: 'El Capino gun',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 76,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 10,
        name: 'El Capino cap',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 76,
        status:"active",
        price:"$1456.00",
    },
    {
        id: 11,
        name: 'El Capino Hat',
        img: "https://images.pexels.com/photos/1152994/pexels-photos-1152994.jpeg",
        stock: 76,
        status:"active",
        price:"$1456.00",
    },
  ];
  